import { getDevelopmentTypeName } from "@/components/shared/investment-card";
import { capitalizeFirstLetter } from "@/utils/capitalizeFirstLetter";
import moment from "moment";
import React from "react";

interface Person {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  join_date?: string;
  phone_number?: string;
}

const About = ({
  status,
  proposedLocation,
  investmentType,
  description,
  developmentStage,
  bathroomCount,
  bedroomCount,
  furnished,
  propertyType,
  realtor,
  owner,
}: {
  status: string;
  proposedLocation: string;
  investmentType: string;
  description: string;
  developmentStage: string;
  bathroomCount: number;
  bedroomCount: number;
  furnished: boolean;
  propertyType: string;
  realtor: Person;
  owner: Person;
}) => {
  return (
    <div className="p-4 bg-grey-6 rounded-lg">
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Status</p>
          <p className="text-gray-800 text-sm font-bold">
            {capitalizeFirstLetter(status)}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Proposed Location</p>
          <p className="text-gray-800 text-sm font-bold">{proposedLocation}</p>
        </div>
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Offering Type</p>
          <p className="text-gray-800 text-sm font-bold max-w-[50%] truncate">
            {capitalizeFirstLetter(
              getDevelopmentTypeName(investmentType)?.toLocaleLowerCase() ?? "",
            )}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Description</p>
          <p
            className="text-gray-800 text-sm font-bold max-w-[50%] truncate"
            title={description}
          >
            {description}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Development Stage</p>
          <p
            className="text-gray-800 text-sm font-bold max-w-[50%] truncate"
            title={developmentStage}
          >
            {capitalizeFirstLetter(developmentStage)}
          </p>
        </div>
        {/* <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Bathrooms</p>
          <p className="text-gray-800 text-sm font-bold">{bathroomCount}</p>
        </div>
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Bedrooms</p>
          <p className="text-gray-800 text-sm font-bold">{bedroomCount}</p>
        </div> */}
        {/* <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Furnished</p>
          <p className="text-gray-800 text-sm font-bold">
            {furnished ? "Yes" : "No"}
          </p>
        </div> */}
        {/* <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Property Type</p>
          <p
            className="text-gray-800 text-sm font-bold max-w-[50%] truncate"
            title={propertyType}
          >
            {propertyType}
          </p>
        </div> */}
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Project Owner</p>
          <p className="text-gray-800 text-sm font-bold">
            {realtor?.first_name} {realtor?.last_name}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Realtor Join Date</p>
          <p className="text-gray-800 text-sm font-bold">
            {realtor?.join_date
              ? moment(realtor.join_date).format("DD MMMM, YYYY")
              : "-"}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Owner Name</p>
          <p
            className="text-gray-800 text-sm font-bold max-w-[50%] truncate"
            title={owner?.full_name}
          >
            {owner?.full_name}
          </p>
        </div>
        {/* <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Owner Email</p>
          <p className="text-gray-800 text-sm font-bold max-w-[50%] truncate">
            {owner?.email}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-gray-600 font-medium text-sm">Owner Phone</p>
          <p
            className="text-gray-800 text-sm font-bold max-w-[50%] truncate"
            title={owner?.phone_number}
          >
            {owner?.phone_number}
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default About;
